import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class SelectedDevicesService {
  private selectedDevices: any[] = [];
  private existingSelectedDevices: any[] = [];
  // private modifyChange: any[] = []; // Initialize as an empty array

  

  private selectedDevicesKey = 'selectedDevices';
  private _selectedDevices = new BehaviorSubject<any[]>([]);
  selectedDevices$ = this._selectedDevices.asObservable();
  private assetDevices = new BehaviorSubject<any[]>([]); 
  assestDevicesSubject$ = this.assetDevices.asObservable();
  private disablePlanId = new BehaviorSubject<string>('');
  disablePlanId$ = this.disablePlanId.asObservable();




  private _existingSelectedDevices = new BehaviorSubject<any[]>([]);
  existingSelectedDevices$ = this._existingSelectedDevices.asObservable();
  private modify: boolean = false; // Add the modify property
  private _modify = new BehaviorSubject<boolean>(this.modify); // Create BehaviorSubject
  modify$ = this._modify.asObservable();

  private modifyChange: any[] = []; // Initialize as an empty array
  private _modifySubject = new BehaviorSubject<any[]>(this.modifyChange);
  modifyChange$ = this._modifySubject.asObservable();


  constructor() {}
  setSelectedDevices(devices: any[]) {
    this.selectedDevices = devices;
    this._selectedDevices.next(devices); // Update the BehaviorSubject
  }

  getSelectedDevices(): any[] {
    return this.selectedDevices; // Or return a copy to avoid mutation
  }

  setExistingSelectedDevices(devices: any[]) {
    this.existingSelectedDevices = devices;
    this._existingSelectedDevices.next(devices); // Update the BehaviorSubject
  }

  getExistingSelectedDevices(): any[] {
    return this.existingSelectedDevices; // Or return a copy to avoid mutation
  }

  setModify(value: boolean) {
    this.modify = value;
    this._modify.next(value); // Update the BehaviorSubject
  }

  getModify(): boolean {
    return this.modify;
  }


  setModifyUpdate(modify: any[]) { // Expect an array or object
    this.modifyChange = modify;
    this._modifySubject.next(modify); // Update the BehaviorSubject
  }

  getModifyUpdate(): any[] {
    return this.modifyChange; // Or return a copy to avoid mutation
  }


  setAssetDevices(devices: any[]) {
    const updatedDevices = [...devices]; 
    this.assetDevices.next(updatedDevices);
  }

  setDisbaledId(id: string){
    this.disablePlanId.next(id);
  }
  
}